import error from '../images/error.jpg'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Error = () => {
  const {t} = useTranslation();

  return (
    <Wrapper className='container'>
      <img src={error} alt="" />
      <div style={{paddingBottom: '125px'}}>
        <Link className="link" to='/' >{t('vaiAllaHome')}</Link>
      </div>
    </Wrapper>
  )
}

export default Error;

const Wrapper = styled.div`
  height: calc(100vh - 68px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 300px;
    margin-bottom: 50px;
  }
  .link {
    background-color: var(--logo);
    color: white;
    border: none;
    text-transform: uppercase;
    padding: 7px 15px;
    border-radius: 5px;
  }
`
